export class TranslationConfiguration {
  menu: MenuTranslation;
  attribute: AttributeTranslation;
  functions: FunctionsTranslation;
  operators: OperatorsTranslation;
  search: SearchTranslation;
  replace: ReplaceTranslation;
  validation: ValidationTranslation;
  generator: GeneratorTranslation; 
  of: string;
  pin: string;
  columnTitle: string;
  popUpTitle: string;
}

export class MenuTranslation {
  saveAndClose: string;
  reset: string;
  undo: string;
  redo: string;
  validate: string;
  neutralDesignation: string;
}

export class AttributeTranslation {
  title: string;
  keyColumns: string;
  systemColumns: string;
}

export class FunctionsTranslation {
  title: string;
}

export class OperatorsTranslation {
  title: string;
  changePosition: string;
  unpin: string;
}

export class SearchTranslation {
  title: string;
  matchCase: string;
  wohleWord: string;
  previousMatch: string;
  nextMatch: string;
  allMatch: string;
  results: string;
  noResults: string;
  placeholder: string;
}

export class ReplaceTranslation {
  title: string;
  placeholder: string;
  one: string;
  all: string;
}

export class ValidationTranslation {
  title: string;
  expressionChanged: string;
  valid: string;
  invalid: string;
  button: string;
  isRefError: string;
  typeError: string;
}

export class GeneratorTranslation {
  title: string;
  placeholder: string;
  errorMessage: string;
  noResult: string;
  assistantName: string;
}
export enum UiSettings {
  popupWidth = '70vw',
  popupHeight = '80%',
  popupMinWidth = 840, //MOH : if you want to change this value you should take in consideration when user pin in navigation 3 Items(entiy , function , opeartor)
  popupMinHeight = 420,
  menuHeight = 40,
  navigationWidth = 40,
  editorMinWidth = 200,
  splitterMinWidth = 200,
  sidbarItemWidth = 200,
  lineNumberWidth = 35,
}

export enum NodeTypeFilter {
  Key = 'key',
  system = 'preferences',
}

export enum SplitterEnum {
  entity,
  function,
  parameter,
  ai 
}

export class Splitter {
  maxWidth: () => number;
  constructor(data: Splitter) {
    Object.assign(this, data);
  }
}

export class UiConfig {
  width: () => number;
  height?: () => number;
}

export enum UiEnum {
  operator,
  editorContainer,
  editorBody,

  editorTitle,
}
